import { render, staticRenderFns } from "./MdCommandEditorModal.vue?vue&type=template&id=2f610e9a&scoped=true&"
import script from "./MdCommandEditorModal.vue?vue&type=script&lang=js&"
export * from "./MdCommandEditorModal.vue?vue&type=script&lang=js&"
import style0 from "./MdCommandEditorModal.vue?vue&type=style&index=0&id=2f610e9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f610e9a",
  null
  
)

export default component.exports